import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchEvaluateContext, putEvaluateContext } from '../../../api';
import { notify, getDictionary } from '../../../utils'

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {}
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = 'toc') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchEvaluateContext(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => this.setState({ is_loading: false, data }))
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putEvaluateContext(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data.evaluate
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.evaluate || this.state.is_loading) return <span>Loading data...</span>
    let { evaluate } = this.state.data;
    return (
      <React.Fragment>
        <div>
          <p>Before writing your ToC, you need to analyze the local context of your P/CVE intervention. The following guiding questions will help you with this.</p>
          <p>{this.getText('evaluate_context_strengths_question')}</p>

          <FormInput
            value={evaluate.questions.strengths}
            onChange={(strengths) => {
              let { evaluate } = this.state.data;
              evaluate.questions.strengths = strengths;
              this.setState({
                data: {
                  ...this.state.data,
                  evaluate
                }
              });
            }}

            placeholder="" />

          <p>{this.getText('evaluate_context_political_atmosphere_question')}</p>
          <FormInput
            value={evaluate.questions.political_atmosphere}
            onChange={(political_atmosphere) => {
              let { evaluate } = this.state.data;
              evaluate.questions.political_atmosphere = political_atmosphere;
              this.setState({
                data: {
                  ...this.state.data,
                  evaluate
                }
              });
            }}

            placeholder="" />

          <p>{this.getText('evaluate_context_social_atmosphere_question')}</p>
          <FormInput
            value={evaluate.questions.social_atmosphere}
            onChange={(social_atmosphere) => {
              let { evaluate } = this.state.data;
              evaluate.questions.social_atmosphere = social_atmosphere;
              this.setState({
                data: {
                  ...this.state.data,
                  evaluate
                }
              });
            }}

            placeholder="" />

          <p>{this.getText('evaluate_context_economic_atmosphere_question')}</p>
          <FormInput
            value={evaluate.questions.economic_atmosphere}
            onChange={(economic_atmosphere) => {
              let { evaluate } = this.state.data;
              evaluate.questions.economic_atmosphere = economic_atmosphere;
              this.setState({
                data: {
                  ...this.state.data,
                  evaluate
                }
              });
            }}

            placeholder="" />
        </div>

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ToCEvaluateContextFormularies.js